<template>
  <div class="footer">
    <p>© 2022 ibaypay.com, all rights reserved</p>
    <p><a href="https://beian.miit.gov.cn" target="_blank">沪ICP备18038983号-1</a></p>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  components: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
</style>
